import { useEffect, useState } from 'react';
import EmployeeResponse from '../model/Employee.model';
import EmployeeService from '../service/employee-service/Employee.service';
import useUserStorage from './useUserStorage';

const useEmployee = () => {
  const [employee, setEmployee] = useState<EmployeeResponse | null>(null);
  const { user } = useUserStorage();

  const getEmployee = async () => {
    const data = await EmployeeService.getEmployeeByUserId(user?.id || 0);
    setEmployee(data);
  };

  useEffect(() => {
    if (user) {
      getEmployee();
    }
  }, [user]);

  return { employee, setEmployee };
};

export default useEmployee;
